import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { alpha, Grid } from "@mui/material";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";

function Features({ data = [] }) {
  return (
    <Container id="features" maxWidth="lg" sx={{ paddingY: 5 }}>
      <Typography variant="h3" marginBottom={3}>
        Features
      </Typography>
      <Grid spacing={2} container>
        {_.map(data, (item) => {
          let iconAndColor = item.icon?.split("&");
          let iconName = _.first(iconAndColor);
          let color = _.last(iconAndColor);

          return (
            <Grid
              key={item.title}
              size={{ xs: 6 * item.gridSize, md: 3 * item.gridSize }}
              bgcolor={alpha(color, 0.15)}
              borderRadius={2}
            >
              <Stack alignItems="center" padding={3} spacing={1}>
                <FontAwesomeIcon
                  icon={`fa-solid fa-${iconName}`}
                  size="3x"
                  color={color}
                />
                <Typography
                  variant="subtitle1"
                  textAlign="center"
                  color={color}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" textAlign="center">
                  {item.description}
                </Typography>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}

export default Features;
